var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"hero"},[_c('div',{staticClass:"hero-body"},[_c('div',{staticClass:"container"},[_c('WtTitle',{attrs:{"h1":""}},[_vm._v("FORBIDDEN")])],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }